export default __webpack_public_path__ + "static/media/frame5.8f5816ef.webp";